module.exports = __webpack_public_path__ + "img/symbol_2.67a1075c.png";